import { useEffect, useState } from 'react';
import { toastSuccess } from 'src/services/toast';
import { checkCampaignCredits } from 'src/services/billing';
import FusionLoading from 'src/components/common/FusionLoading';
import { Box, Text } from '@chakra-ui/react';

const CampaignTopupSuccess = () => {
	const [ready, setReady] = useState(false);

	useEffect(() => {
		// Get campaignId from URL parameters
		const urlParams = new URLSearchParams(window.location.search);
		const campaignId = urlParams.get('campaignId');

		if (!campaignId) {
			setReady(true);
			return;
		}

		let intervalId: NodeJS.Timeout;
		let timeoutId: NodeJS.Timeout;
		const startTime = Date.now();

		const pollCredits = async () => {
			try {
				const creditCheckResponse = await checkCampaignCredits(campaignId);

				if (creditCheckResponse.hasEnoughCredits) {
					setReady(true);
					clearInterval(intervalId);
					clearTimeout(timeoutId);
				} else if (Date.now() - startTime > 5000) {
					setReady(true);
					clearInterval(intervalId);
				}
			} catch (error) {
				console.error('Error checking credits:', error);
				if (Date.now() - startTime > 5000) {
					setReady(true);
					clearInterval(intervalId);
				}
			}
		};

		pollCredits();
		intervalId = setInterval(pollCredits, 500);
		timeoutId = setTimeout(() => {
			clearInterval(intervalId);
			setReady(true);
		}, 5000);

		return () => {
			clearInterval(intervalId);
			clearTimeout(timeoutId);
		};
	}, []);

	useEffect(() => {
		if (ready) {
			const previousUrl = sessionStorage.getItem('previousUrl');

			// Show success message
			toastSuccess('Credits added successfully to your account');

			if (previousUrl) {
				// Add parameter to continue launch process
				const urlParams = new URLSearchParams();
				urlParams.set('continueLaunch', 'true');

				const separator = previousUrl.includes('?') ? '&' : '?';
				const redirectUrl = `${previousUrl}${separator}${urlParams.toString()}`;

				// Clear the stored URL
				sessionStorage.removeItem('previousUrl');

				// Redirect with the parameter
				setTimeout(() => {
					window.location.href = redirectUrl;
				}, 1000);
			} else {
				// Fallback redirect to home
				setTimeout(() => {
					window.location.href = '/home';
				}, 1000);
			}
		}
	}, [ready]);

	return (
		<Box display="flex" justifyContent="center">
			<Box textAlign="center">
				<FusionLoading isLoading={true} />
				<Text size="md" mt={4}>
					{ready
						? 'Redirecting back to your campaign...'
						: 'We are updating your credits balance'}
				</Text>
			</Box>
		</Box>
	);
};

export default CampaignTopupSuccess;
